module.exports = __webpack_public_path__ + "img/의사소통.2984e52c.png";